import { FETCH_FAVORITES, FETCH_FAVORITES_SUCCESS } from '../actions/FavoritesActions';

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_FAVORITES:
      return {
        ...state,
        loading: true,
      };
    case FETCH_FAVORITES_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        data: action.payload.data,
      };

    default:
      return state;
  }
};
